import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import axios from "axios";
import toastify from "../../config/toastify";
import { baseUrl } from "../../config/baseUrl";


export default function Settings() {

    const navigate = useNavigate();
    const [formval, setFormval] = useState({
        email_id: "",
        phone_number: "",
        address: "",
        facebook: "",
        twitter: "",
        instagram: "",
        linkedin: "",
        whatsapp_number: ""
    });

    let changeHandler = (e) => {
        setFormval((preVal) => ({ ...preVal, [e.target.name]: e.target.value }));
    };
    // let navigate = useNavigate();

    const [setting, setSetting] = useState({});
    const fetchLiveData = async () => {
        try {
            const response = await axios.get(
                // `https://instructo.teachera.co/setting`,
                `${baseUrl}/setting/setting-details`,
                {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                    },
                }
            );

            setFormval(response.data.data[0]);
        } catch (error) {
            console.log("error", error);
        }
    };

    useEffect(() => {
        fetchLiveData();
    }, []);

    const id = formval._id;

    let handleSubmit = async (e) => {
        e.preventDefault();



        try {
            let response = await axios(
                // `https://instructor.teachera.co/setting/${id}`,
                `${baseUrl}/setting/setting-update/${id}`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: localStorage.getItem("token"),
                        "Content-Type": "application/json",
                    },
                    data: formval,
                }
            );
            if (!response?.data?.status) {
                toastify.error("some error accoured");
            } else {
                toastify.success("Settings updated");
            }
            navigate(`/settings`);
        } catch (error) {
            console.error("Error :", error);
        }
    };

    return (
        <>
            <section className="main-sec">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="dashboard-title">
                            <h4 className="dash-head">
                                <i className="fa fa-users me-2" />
                                Manage Settings
                            </h4>
                        </div>
                        <div className="custom-bredcump">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Manage Settings
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-end">
                        <Link to="/" className="btn btn-info text-white">
                            <i className="fa fa-arrow-left me-1"></i>
                            Back
                        </Link>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="cards edit-usr">
                            <form action="" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="address" className="form-label">
                                            Address<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="address"
                                            id="address"
                                            placeholder="Category Name"
                                            onChange={changeHandler}
                                            value={formval?.address}
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="phone_number" className="form-label">
                                            Phone Number<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="phone_number"
                                            id="phone_number"
                                            placeholder="Phone Number"
                                            onChange={changeHandler}
                                            value={formval?.phone_number}
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="email_id" className="form-label">
                                            Email Address<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="email_id"
                                            id="email_id"
                                            placeholder={formval?.email_id}
                                            onChange={changeHandler}
                                            value={formval?.email_id}
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="whatsapp_number" className="form-label">
                                            Whatsapp Number<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="whatsapp_number"
                                            id="whatsapp_number"
                                            placeholder={formval?.whatsapp_number}
                                            onChange={changeHandler}
                                            value={formval?.whatsapp_number}
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="facebook" className="form-label">
                                            FaceBook<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="url"
                                            className="form-control"
                                            name="facebook"
                                            id="facebook"
                                            placeholder={formval?.facebook}
                                            onChange={changeHandler}
                                            value={formval?.facebook}
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="twitter" className="form-label">
                                            Twitter<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="url"
                                            className="form-control"
                                            name="twitter"
                                            id="twitter"
                                            placeholder={formval?.twitter}
                                            onChange={changeHandler}
                                            value={formval?.twitter}
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="instagram" className="form-label">
                                            Instagram<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="instagram"
                                            id="instagram"
                                            placeholder="Instagram"
                                            onChange={changeHandler}
                                            value={formval?.instagram}
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="linkedin" className="form-label">
                                            Linkedin<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="linkedin"
                                            id="linkedin"
                                            placeholder="Category Name"
                                            onChange={changeHandler}
                                            value={formval?.linkedin}
                                        />
                                    </div>

                                    <div className="col-lg-12 text-center">
                                        <button
                                            type="Submit"
                                            className="btn btn-for-add text-white"
                                        >
                                            <i className="fa fa-save me-1"></i>
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
